export const DEFAULT_LATITUDE = 55.869602;
export const DEFAULT_LONGITUDE = -120.608871;
export const DEFAULT_ZOOM = 5;

// Publishable Mapbox token (pk.* tokens are not secrets and already ship in the bundle) —
// shared by both the personal (DefaultMapSettings.tsx) and organization
// (OrganizationMapDefaults.tsx) map-defaults panels so the literal has a single call site.
export const MAPBOX_ACCESS_TOKEN =
  (process.env.REACT_APP_MAPBOX_ACCESS_TOKEN as string) ||
  "pk.eyJ1IjoiaG9kYTk5IiwiYSI6ImNrMWxhcngydDAzcXMzbXA3dGs3Ym5vMjYifQ.Aao1Lz2YhOUIpJLi2ZplHw";
